<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <template v-if="isReadyToDraw">
      <div class="rentalcar-header">
        <div class="index-content-left">
          <div
            class="list-item__thumbnail"
            :style="backgroundImageFromApi(rental_car.Office.Supplier.img)"
          />
        </div>
        <div class="index-content-right">
          <div class="list-item item__1">
            <a>{{ rental_car.Office.Supplier.name }}</a>
          </div>
          <p class="list-item__title item__2">{{ rental_car.Office.name }}</p>
          <p class="list-item__title item__3">
            {{ rental_car.Office.address }}
          </p>
        </div>

        <div class="location-info">
          <a @click="goToExternalLink(rental_car.Office.tabiraiServiceLink)">
            <div class="site-link">たびらいレンタカーを開く</div>
          </a>
        </div>
      </div>

      <div class="rentalcar-content">
        <div class="access list">
          <h2>アクセス</h2>
          <p v-html="newlineConvert(rental_car.Office.access)" />
        </div>

        <div class="bussiness-time list">
          <h2>営業時間</h2>
          <p v-for="(d, index) in rental_car.Office.businessHour" :key="index">
            {{ aWeekArray[index] }} {{ d.startTime }} ~ {{ d.endTime }}
          </p>
        </div>
      </div>

      <div>
        <button class="bottom-button" @click="ncGotoPlaceRentalCar(rental_car)">
          ここへ行く
        </button>
      </div>
    </template>
    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />
  </div>
</template>

<script>
import storeJS from "@/store";

// ネイティブから送られてくる情報をストアへ格納
window.jcSetRentalCarInfo = function (info) {
  storeJS.commit("rental_car/setRentalCar", info);
};

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      index: this.$route.params.index,
      aWeekArray: [],
    };
  },
  async mounted() {
    var that = this;
    for (var i = 0; i < 7; i++) {
      var day = this.$moment(new Date())
        .add(i, "d")
        .format("YYYY年MM月DD日(ddd)");
      that.aWeekArray.push(day);
    }
    console.log("this.aWeekArray :>> ", this.aWeekArray);
  },
  methods: {
    async setInfoToStore(info) {
      await this.$store.commit("rental_car/setRentalCar", info);
    },
  },
  computed: {
    isReadyToDraw() {
      return this.rental_car;
    },
    ...mapGetters("rental_car", ["rental_car"]),
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  padding-bottom: 65px; /* 「ここへ行く」がある分、パディングを取る必要がある */
}

.rentalcar-header {
}

.index-content-left {
  float: left;
  width: 20%;
  padding: 9px 10px 9px 10px;
}

.list-item__thumbnail {
  width: 76px;
  height: 76px;
  border-radius: 0px;
  background-size: cover;
}

.cb {
  clear: both;
}

.index-content-right {
  overflow: hidden;
  position: relative;
  width: 65%;
  height: 76px;
  padding-top: 10px;
}

.list-item__title {
  font-size: 15px;
  position: absolute;
  top: 54%;
  height: 1.5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  line-height: 1.2em;
}

.list-item {
  position: absolute;
  width: 100%;
  height: 4vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.item__1 {
  top: 23%;
  font-size: 11px;
}
.item__2 {
  top: 45%;
}
.item__3 {
  top: 75%;
  font-size: 11px;
  color: grey;
}

.location-info {
  width: 95%;
  margin: auto;
  padding-top: 10px;
  border-top: 1px solid #f5f5f5;
}

.site-link {
  font-size: 13px;
  color: black;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border: 1px solid #e7e7e7;
  padding: 13px 0;
  margin: 0 auto;
  border-radius: 5px;
}

.rentalcar-content {
  width: 95%;
  margin: auto;
  margin-top: 10px;
  font-size: 13px;
  .list {
    margin: 30px 0;
  }
  .list:first-child {
    margin-top: 10px;
  }

  p {
    margin-top: 5px;
  }
}
.bottom-button {
  background: #ffb206;
  width: 100%;
  display: block;
  border: none;
  /* margin: 0.5vw auto; */
  font-size: 13px;
  color: white;
  font-weight: bold;
  height: 42px;
  position: fixed;
  bottom: 0;
  border-radius: 0px 0px 10px 10px;
}
</style>
